import controlesIcon from '../../../images/controlesSideBarIcon.svg';
import metierIcon from '../../../images/metierSideBarIcon.svg';
import polesIcon from '../../../images/polesSideBarIcon.svg';
import sitesIcon from '../../../images/sitesSideBarIcon.svg';
import { FormatDate } from '../../../utils/formatDate';
import { hasDisplayValue, hasFormattedDate } from '../../../utils/publicMachineDisplayUtils';
import calender from '../../../images/calender.svg';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MachineStatus from '../machineStatus';
import Iconify from '../../Iconify';
import '../../../css/machines/localisationEtStatut.css';

const PublicMachineLocalisationEtStatut = ({ machine }) => {

    const { t } = useTranslation();

    const metiers = machine?.machine_metier
        ?.map((entry) => entry?.metier?.name)
        .filter((name) => hasDisplayValue(name)) || [];

    const hasLocalisation = hasDisplayValue(machine?.region?.name)
        || hasDisplayValue(machine?.site?.name)
        || hasDisplayValue(machine?.pole?.name)
        || metiers.length > 0;

    const controlDate = FormatDate(machine?.machine_control?.[0]?.control_date);
    const hasControle = hasDisplayValue(machine?.status) || hasFormattedDate(machine?.machine_control?.[0]?.control_date);

    if (!hasLocalisation && !hasControle) {
        return null;
    }

    return (
        <Box className='localisationEtStatut_main_box'>
            {hasLocalisation && (
                <Box className='localisationEtStatut_box'>
                    <Box className='localisation_edit_box'>
                        <Typography className='localisationEtStatut_title'>{t('Localisation et rattachement')}</Typography>
                    </Box>
                    {hasDisplayValue(machine?.region?.name) && (
                        <Box className='localisationEtStatut_icon_title_response_box'>
                            <Iconify icon="oui:vis-map-region" width="32px" />
                            <Box className='localisationEtStatut_response_box'>
                                <Typography className='localisationEtStatut_text'>{t('Region :')}</Typography>
                                <Typography className='localisationEtStatut_text_localisation'>{machine.region.name}</Typography>
                            </Box>
                        </Box>
                    )}
                    {hasDisplayValue(machine?.site?.name) && (
                        <Box className='localisationEtStatut_icon_title_response_box'>
                            <img src={sitesIcon} alt="icon" loading='lazy' decoding='async' />
                            <Box className='localisationEtStatut_response_box'>
                                <Typography className='localisationEtStatut_text'>{t('Site :')}</Typography>
                                <Typography className='localisationEtStatut_text_localisation'>{machine.site.name}</Typography>
                            </Box>
                        </Box>
                    )}
                    {hasDisplayValue(machine?.pole?.name) && (
                        <Box className='localisationEtStatut_icon_title_response_box'>
                            <img src={polesIcon} alt="icon" loading='lazy' decoding='async' />
                            <Box className='localisationEtStatut_response_box'>
                                <Typography className='localisationEtStatut_text'>{t('Pole :')}</Typography>
                                <Typography className='localisationEtStatut_text_localisation'>{machine.pole.name}</Typography>
                            </Box>
                        </Box>
                    )}
                    {metiers.length > 0 && (
                        <Box className='localisationEtStatut_icon_title_response_box'>
                            <Box className='localisationEtStatut_icon_title_box'>
                                <img src={metierIcon} alt="icon" loading='lazy' decoding='async' />
                                <Typography className='localisationEtStatut_text'>{t('Métiers :')}</Typography>
                            </Box>
                            <Box className='localisationEtStatut_response_box'>
                                <Box className='localisationEtStatut_text_metier_array'>
                                    {metiers.map((name) => (
                                        <Typography className='localisationEtStatut_text_metier' key={name}>{name}</Typography>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
            )}
            {hasControle && (
                <Box className='localisationEtStatut_box'>
                    <Box className='localisation_edit_box'>
                        <Typography className='localisationEtStatut_title'>{t('Contrôle Sécurité')}</Typography>
                    </Box>
                    {hasDisplayValue(machine?.status) && (
                        <Box className='localisationEtStatut_icon_title_response_box'>
                            <img src={controlesIcon} alt="icon" loading='lazy' decoding='async' />
                            <Typography className='localisationEtStatut_text'>
                                {t('Statut contrôle :')} <MachineStatus status={machine.status} />
                            </Typography>
                        </Box>
                    )}
                    {hasFormattedDate(machine?.machine_control?.[0]?.control_date) && (
                        <Box className='localisationEtStatut_icon_title_response_box'>
                            <img src={calender} alt="icon" style={{ width: '30px', height: '25px', padding: '3px' }} loading='lazy' decoding='async' />
                            <Typography className='localisationEtStatut_text'>
                                {t('Date contrôle :')}{' '}
                                <Typography component="span" className='localisationEtStatut_text_statut_controle'>
                                    {controlDate}
                                </Typography>
                            </Typography>
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default PublicMachineLocalisationEtStatut;
